import React, { Component } from 'react';
import './Heading.css';
import headerImage from '../../assets/imgs/header__company.jpg';
import PropTypes from 'prop-types';

// IE detect
let isIE = false;
if (typeof (document) !== 'undefined') {
  isIE = false || !!document.documentMode;
}

const nameSize = (size) => {
  let nameSize = 24 / size.length;
  // 1.286 = min-font-size in rem
  if (nameSize < 1.286) {
    return 1.286 + 'rem';
  } else {
    return nameSize + 'rem';
  }
}

class Heading extends Component {
  static contextTypes = {
    width: PropTypes.number
  };

  render() {
    return (
      <div className={`heading ${this.props.modifier ? this.props.modifier : ''}`}
        style={{ backgroundImage: `url(${(this.props.background && !(this.props.background.indexOf('null') !== -1)) ? (this.context.width <= 1024 ? this.props.background__1024 : this.props.background) : headerImage})` }}
      >
        {(this.props.name || this.props.logo) &&
          <div className={
            `container container--center
            ${(this.props.modifier && this.props.modifier.indexOf('heading--fullHeight') !== -1) ?
              `heading__floatContent ${isIE ? 'heading__floatContent--around' : ''}` : ''}`
          }>
            {
              this.props.logo &&
              <img className="heading__logo" src={this.props.logo} alt={this.props.name} />
            }
            {
              this.props.name &&
              <h1 className="heading__name" style={{ fontSize: nameSize(this.props.name) }}>{this.props.name}</h1>
            }
          </div>
        }
        {
          ((this.props.modifier && this.props.modifier.indexOf('heading--fullHeight') !== -1) || this.props.withoutBG) &&
          <img className={`heading__backgroundImage ${isIE ? 'heading__backgroundImage--fullHeight' : ''}`} src={this.props.background} alt={this.props.name || 'Фоновое изображение'} />
        }
        {
          this.props.withoutBG ?
            <div className={`heading__floatContent ${isIE ? 'heading__floatContent--around' : ''}`}>{this.props.children}</div>
            :
            this.props.children
        }
      </div>
    );
  }
}

export default Heading;



// WEBPACK FOOTER //
// ./src/components/Heading/index.js